export { AudioWave, formWaveSurferOptions } from './AudioWave'
